import { isObject } from '@cutwise/utils';

import Storage, { KEY_COLLECTION_PREVIEWS } from '@/common/services/Storage';
import { PreviewFragment } from '@/media/types/PreviewResponse';

type CollectionPreviewMap = Record<string, PreviewFragment[]>;

class CollectionPreviewStorage {
  static get(): CollectionPreviewMap {
    const value = Storage.getObject(KEY_COLLECTION_PREVIEWS, Storage.STORAGE_LOCAL);

    return isObject(value) ? (value as CollectionPreviewMap) : {};
  }

  static save(state: CollectionPreviewMap) {
    Storage.saveObject(KEY_COLLECTION_PREVIEWS, state, Storage.STORAGE_LOCAL);
  }
}

export default CollectionPreviewStorage;
